import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import {
  allAssignmentsStateConfig,
  childAssignmentsStateConfig,
  childAssignmentStateConfig,
  currentAssignmentsStateConfig
} from "../../../consts";
import AssignmentMeta from "../../../models/StudentAssignmentsMetaState";

const allStudentAssignmentsCrudMetaReducer = makeCrudStateReducer(
  allAssignmentsStateConfig
);

const currentStudentAssignmentsCrudMetaReducer = makeCrudStateReducer(
  currentAssignmentsStateConfig
);

const childAssignmentsCrudMetaReducer = makeCrudStateReducer(
  childAssignmentsStateConfig
);

const childAssignmentCrudMetaReducer = makeCrudStateReducer(
  childAssignmentStateConfig
);

export default combineReducers(
  {
    pastAssignments: allStudentAssignmentsCrudMetaReducer,
    futureAssignments: currentStudentAssignmentsCrudMetaReducer,
    childAssignments: childAssignmentsCrudMetaReducer,
    childAssignment: childAssignmentCrudMetaReducer
  },
  () => new AssignmentMeta() as any
);
